import React from 'react';
import './HeaderDE.css';
import Logo from '../../../assets/rewboxlogo3.png';
import { Link } from 'react-router-dom';

const HeaderDE = ({ backcolor = `rgb(56, 209, 107)` }) => {
  return (
    <div
      className="sr-header-container"
      style={{ background: `linear-gradient(to right, ${backcolor}, #FFD700)` }}
    >
      <div className="header-left-item">
        <img className="header-logo1" src={Logo} alt="Logo"></img>
      </div>
      <div className="header-right-item">
        <Link to="/de/agb" target="_blank" rel="noopener noreferrer">
          AGB
        </Link>
      </div>
    </div>
  );
};

export default HeaderDE;
